import { lazy, type ComponentType, type LazyExoticComponent } from 'react';

export function isChunkLoadError(error: unknown): boolean {
  const message =
    error instanceof Error
      ? error.message
      : typeof error === 'string'
        ? error
        : String(error ?? '');
  return /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Loading chunk [\d]+ failed/i.test(
    message
  );
}

/**
 * React.lazy with a single retry for transient chunk fetch failures.
 * Does not auto-reload the page — that races OIDC and can strand users in a login loop.
 */
export function lazyWithRetry(
  factory: () => Promise<{ default: ComponentType }>
): LazyExoticComponent<ComponentType> {
  return lazy(async () => {
    try {
      return await factory();
    } catch (first) {
      if (!isChunkLoadError(first)) throw first;
      await new Promise((r) => setTimeout(r, 250));
      return await factory();
    }
  });
}
